import { render, staticRenderFns } from "./TopProvincesChart.vue?vue&type=template&id=2a68ec20&scoped=true"
import script from "./TopProvincesChart.vue?vue&type=script&lang=js"
export * from "./TopProvincesChart.vue?vue&type=script&lang=js"
import style0 from "./TopProvincesChart.vue?vue&type=style&index=0&id=2a68ec20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68ec20",
  null
  
)

export default component.exports